/**
 * Triggers a browser download of a PDF blob
 */
export function downloadPdf(
  pdfBlob: Blob,
  fileName: string = "Vertrag.pdf"
): void {
  try {
    // Create a URL for the blob
    const url = URL.createObjectURL(pdfBlob);

    // Create a temporary anchor element
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object
    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 100);

    console.log(`PDF download triggered: ${fileName}`);
  } catch (error) {
    console.error("Error downloading PDF:", error);
    throw error;
  }
}

/**
 * Generates a filename for the contract PDF
 */
export function generateContractFilename(
  customerLastName: string,
  contractType?: string
): string {
  const date = new Date();
  const dateString = date.toISOString().split("T")[0]; // YYYY-MM-DD
  const sanitizedName = customerLastName.replace(/[^a-zA-Z0-9]/g, "_");
  const typePrefix = contractType
    ? `${contractType.replace(/[^a-zA-Z0-9]/g, "_")}_`
    : "";

  return `${typePrefix}Vertrag_${sanitizedName}_${dateString}.pdf`;
}
